module.exports = __webpack_public_path__ + "img/NewPost.bae99be5.svg";